//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from '@apollo/client/core'
import moneyMixin from '@/mixins/moneyMixin'
import { ApolloClient } from '@/vue-apollo'
import { mapMutations } from 'vuex'

export default {
  mixins: [moneyMixin],
  data() {
    return {
      filter: '',
      selected: [],
      expanded: [],
      pagination: {
        sortBy: 'desc',
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10
      },
      visibleColumnsDesktop: [
        'Expand',
        'Invoice ID',
        'Reference',
        'Date issued',
        'Opening balance',
        'Debits',
        'Credits',
        'Closing balance',
        'PDF',
        'CSV',
        'Resend'
      ],
      visibleColumnsMobile: [
        'Date issued',
        'Opening balance',
        'Debits',
        'Credits',
        'Closing balance'
      ],
      columns: [
        {
          name: 'Expand'
        },
        {
          name: 'Invoice ID',
          label: 'Invoice ID',
          field: 'invoice_number',
          align: 'left',
          format: val => 'INV#' + val
        },
        {
          name: 'Reference',
          label: 'Reference',
          field: 'id',
          align: 'left',
          format: val => 'REF#' + val
        },
        {
          name: 'Date issued',
          label: 'Date issued',
          field: 'date_issued',
          align: 'left',
          format: val => {
            let d = new Date(val)
            return d.toDateString()
          }
        },
        {
          name: 'Opening balance',
          label: 'Opening balance',
          field: 'opening_balance',
          format: val => this.centsToDollarsDisplay(val)
        },
        {
          name: 'Debits',
          label: 'Debits',
          field: 'debits',
          format: val => this.centsToDollarsDisplay(val)
        },
        {
          name: 'Credits',
          label: 'Credits',
          field: 'credits',
          format: val => this.centsToDollarsDisplay(val)
        },
        {
          name: 'Closing balance',
          label: 'Closing balance',
          field: 'closing_balance',
          format: val => this.centsToDollarsDisplay(val)
        },
        {
          name: 'PDF',
          label: 'PDF',
          align: 'center'
        },
        {
          name: 'CSV',
          label: 'CSV',
          align: 'center'
        },
        {
          name: 'Resend',
          label: 'Resend',
          align: 'center'
        }
      ],
      accountInvoices: [],
      loading: true
    }
  },

  methods: {
    onRequest(props) {
      const { page, rowsPerPage } = props.pagination

      this.loading = true
      ApolloClient.query({
        query: gql`
          query Query($account_id: Int!, $rows_per_page: Int!, $page: Int!) {
            accountInvoicesForAccountPaginated(
              account_id: $account_id
              first: $rows_per_page
              page: $page
            ) {
              paginatorInfo {
                total
              }
              data {
                id
                invoice_number
                status
                date_opened
                opening_balance
                credits
                credits_gst
                debits
                debits_gst
                commissions
                commissions_gst
                payments
                closing_balance
                gst_value
                date_issued
                date_sent
                date_closed
              }
            }
          }
        `,
        variables: {
          account_id: parseInt(this.$store.getters.getUserAccountID),
          rows_per_page: parseInt(rowsPerPage),
          page: parseInt(page)
        }
      }).then(result => {
        this.accountInvoices =
          result.data.accountInvoicesForAccountPaginated.data
        this.pagination.rowsNumber =
          result.data.accountInvoicesForAccountPaginated.paginatorInfo.total
        this.pagination.page = page
        this.pagination.rowsPerPage = rowsPerPage
        this.loading = false
      })
    },

    ...mapMutations('billing', ['OPEN_ACCOUNT_INVOICE_QUICK_VIEW']),

    rowClick(rowId) {
      this.OPEN_ACCOUNT_INVOICE_QUICK_VIEW(rowId)
    }
  },

  mounted() {
    // get initial data from server (1st page)
    this.onRequest({
      pagination: this.pagination,
      filter: undefined
    })
  }
}
